import React from 'react';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function OpeningLead() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-270">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-272">
          <Quote className="w-16 h-16 text-brand-gold/30 mx-auto mb-6 rotate-180" data-id="element-273" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-brand-black leading-tight text-balance" data-id="element-274">
            {t('lead.quote')}
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-brand-text/80 font-serif leading-relaxed" data-id="element-275">
          <p data-id="element-276">{t('lead.p1')}</p>

          <p className="font-bold text-brand-black" data-id="element-277">{t('lead.p2')}</p>

          <p data-id="element-278">{t('lead.p3')}</p>

          <p data-id="element-279">{t('lead.p4')}</p>

          <p className="font-bold text-brand-black" data-id="element-280">{t('lead.p5')}</p>

          <p data-id="element-281">{t('lead.p6')}</p>

          <p className="text-2xl font-bold text-brand-goldDark pt-4 text-center" data-id="element-282">
            {t('lead.p7')}
          </p>
        </motion.div>
      </div>
    </section>;
}